export default __webpack_public_path__ + "static/applying-grid-light-680213d4b6bcf558fce3661ffeeed50a194aef36e113bf0cb6469493379b76ff.png";